





























































































import { Component, Vue } from 'vue-property-decorator';
   @Component({ 
    })
export default class CancelFlightOrderModal extends Vue   {
  dialog:boolean= true;
  mockData:any[]=[];
  headers:any[]=[];
  mockDataPaymentDetail:any[]=[];
  headersPaymentDetail:any[]=[];



    created(){

        this.headersPaymentDetail= [
          { text: 'PNR', value: 'pnr' },
          { text: 'Havayolu Adı', value: 'companies' },
          { text: 'Kalkış-Varış', value: 'destination' },
          { text: 'Uçuş Türü', value: 'flightType' },
          { text: 'Sipariş Durumu', value: 'orderStatus' },
          { text: 'Yolcu Sayısı', value: 'passangerCount' },
          { text: 'ToplamÜcret', value: 'totalPrice' },
        ],
        
        this.mockDataPaymentDetail=[
          {
            pnr: '53644',
            companies: 'URAL AIRLINES - U6 1518',
            destination: '05.05.2021 AER - DME 11:00',
            flightType: 'Tek Yön',
            orderStatus: 'Ödeme alındı',
            passangerCount: '1',
            totalPrice: '1,350.00 RUB',
          },
        ],


        this.headers= [
          { text: 'Uçuş', value: 'flight' },
          { text: 'Uçuş Sınıfı', value: 'flightClass' },
          { text: 'Yolcu Durumu', value: 'passengerstatus' },
          { text: 'İsim', value: 'name' },
          { text: 'Yolcu Türü', value: 'passengerType' },
          { text: 'Pasaport', value: 'passport' },
          { text: 'Fiyat', value: 'price' },
          { text: 'Ceza Ücreti', value: 'penaltyFee' },

          
        ],

        this.mockData=[
          { 
            flight: '28755 - U6 1518',
            flightClass: 'X-A',
            passengerstatus: 'Ödeme alındı',
            name: 'AYNULA KAMBULATOV',
            passengerType:'Yetişkin',
            passport:'6716597327-860026',
            price:'1460 RUB',
            penaltyFee:'0 RUB',
          },
        ]




        

    }
  

    data () {
      return {



    }      

    
}
 

    closeDialog(){
      this.$emit('closed');
     
    }


};
